import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { RoutePaths } from '@utils/route.utils.ts';

interface Props {
  children: React.ReactNode;
}

/**
 * Allows access only when the URL carries `?mode=web` (public iframe embed).
 * Otherwise redirects to sign-in, so the App Builder cannot be opened
 * without login outside of web mode.
 */
const WebModeGuard: React.FC<Props> = ({ children }) => {
  const [searchParams] = useSearchParams();

  if (searchParams.get('mode') !== 'web') {
    return <Navigate to={RoutePaths.Auth.SignIn.absolutePath} replace />;
  }

  return <>{children}</>;
};

export default WebModeGuard;
